import React, { useEffect, useMemo, useState } from "react";
import {  useLocation } from "react-router-dom";
import Navbar2 from "../../Components/Navbar2/Navbar2";
import Footer from "../../Components/Footer/Footer";
import "./Legal.css";
import termsConditions from "./termsConditions";
import privacyPolicy from "./privacyPolicy";

const Legal = () => {
    const location = useLocation();

    const legalData = useMemo(() => {
        return location.pathname.includes("privacy")
            ? privacyPolicy
            : termsConditions;
    }, [location.pathname]);

    const [activeSection, setActiveSection] = useState(
        legalData.sections[0]?.id || ""
    );

 

useEffect(() => {
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setActiveSection(entry.target.id);
                }
            });
        },
        {
            rootMargin: "-35% 0px -50% 0px",
            threshold: 0
        }
    );

    const elements = document.querySelectorAll(".legal-section");

    elements.forEach((section) => observer.observe(section));

    return () => {
        observer.disconnect();
    };
}, [legalData]);

    const scrollToSection = (id) => {
        const section = document.getElementById(id);

        if (!section) return;

        section.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    };

    return (
        <>
            <Navbar2 />

            <section className="legal-hero">
                <div className="legal-container">
                    <div className="legal-hero-content">
                      

                        <h1>{legalData.heroTitle}</h1>

                        <p>{legalData.heroDescription}</p>

                        <div className="legal-last-updated">
                            Last Updated
                            <span>{legalData.lastUpdated}</span>
                        </div>
                    </div>
                </div>
            </section>

            <section className="legal-content">
                <div className="legal-container">

                    <aside className="legal-sidebar">
                        <div className="legal-sidebar-card">
                            <h4>Contents</h4>

                            <ul>
                                {legalData.sections.map((section, index) => (
                                    <li
                                        key={section.id}
                                        className={
                                            activeSection === section.id
                                                ? "active"
                                                : ""
                                        }
                                        onClick={() => scrollToSection(section.id)}
                                    >
                                        <span>
                                            {(index + 1)
                                                .toString()
                                                .padStart(2, "0")}
                                        </span>

                                        <p>{section.title}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </aside>

                    <div className="legal-main">
                        {legalData.sections.map((section, index) => (
                            <article
                                key={section.id}
                                id={section.id}
                                className="legal-section"
                            >
                                <div className="legal-card">
                                    <div className="legal-heading">
                                        <span>
                                            {(index + 1)
                                                .toString()
                                                .padStart(2, "0")}
                                        </span>

                                        <h2>{section.title}</h2>
                                    </div>

                                    {section.paragraphs &&
                                        section.paragraphs.map((paragraph, i) => (
                                            <p
                                                key={i}
                                                className="legal-paragraph"
                                            >
                                                {paragraph}
                                            </p>
                                        ))}

                                    {section.list &&
                                        section.list.length > 0 && (
                                            <ul className="legal-list">
                                                {section.list.map((item, i) => (
                                                    <li key={i}>
                                                        {item}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                                                            {section.contact && (
                                        <div className="legal-contact-card">
                                            <h3>Need Assistance?</h3>

                                            <div className="legal-contact-info">
                                                <div className="legal-contact-item">
                                                    <span>Company</span>
                                                    <p>{section.contact.company}</p>
                                                </div>

                                                <div className="legal-contact-item">
                                                    <span>Email</span>
                                                    <a href={`mailto:${section.contact.email}`}>
                                                        {section.contact.email}
                                                    </a>
                                                </div>

                                                <div className="legal-contact-item">
                                                    <span>Website</span>
                                                    <a
                                                        href={section.contact.website}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        {section.contact.website}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

         

            <Footer />
        </>
    );
};

export default Legal;